import { Entities_Player_ProgressSummary_Response } from '@suntex.fim/api-client';

/**
 * Static dummy data for preview mode.
 * Used when playerId === 0 (preview mode) to avoid API calls
 * and provide sensible default values for UI rendering.
 */
export const PREVIEW_PROGRESS_SUMMARY: Entities_Player_ProgressSummary_Response =
  {
    vif: {
      add: 0,
      sub: 0,
      mul: 0,
      div: 0,
    },
    stickers: 0,
    stickers1W: 0,
    stickers2W: 0,
    currentStreak: 0,
    bestStreak: 0,
    winnerCircleCount: 0,
    k2Enabled: false,
    games: {},
    bonusGoldCount: 0,
    mwGoldCount: 0,
    k2GoldCount: 0,
    ss: {},
    gyms: {
      num: {
        add: {},
        sub: {},
        mul: {},
        div: {},
      },
      frc: {
        add: {},
        sub: {},
        mul: {},
        div: {},
      },
      dec: {
        add: {},
        sub: {},
        mul: {},
        div: {},
      },
      int: {
        add: {},
        sub: {},
        mul: {},
        div: {},
      },
      k2: {
        add: {},
        sub: {},
        mul: {},
        div: {},
      },
    },
    jtf: {},
    ks: {
      1: {},
      2: {},
      3: {},
      4: {},
      5: {},
      6: {},
      7: {},
      8: {},
    },
  };
